import { ActionReducerMap } from '@ngrx/store';
import { SharedState, sharedReducer } from '../shared/store/shared.reducers';
import { CatalogsState, catalogsReducer } from '../features/catalogs/store/catalogs.reducers';
import { WishlistState, wishlistReducer } from '../features/wishlist/store/wishlist.reducers';
import { quotationsReducer, quotationsState } from '../features/quotes/store/quotes.reducers';
import { ordersReducer, ordersState } from '../features/orders/store/orders.reducers';

export interface AppState {
  shared: SharedState;
  catalogs: CatalogsState;
  wishlist: WishlistState;
  quotes: quotationsState;
  orders: ordersState;
}
export const reducers: ActionReducerMap<AppState> = {
  shared: sharedReducer,
  catalogs: catalogsReducer,
  wishlist: wishlistReducer,
  quotes: quotationsReducer,
  orders: ordersReducer,
};
